import React from "react";
import TakeOff from "./Components/TakeOff";

const App = () => <TakeOff />;

export default App;
